// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px;
  margin: 0;
  border-radius: 20px;
  background: var(--default-background);
}
.container .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.container .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.title {
  font-family: AppFontMedium, sans-serif;
  font-size: 28px;
  line-height: 23px;
  letter-spacing: normal;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 15px;
  text-transform: capitalize;
}

.info {
  font-family: AppFont, sans-serif;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: normal;
  text-align: center;
  color: var(--color-black);
  text-transform: none;
}

.button {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 25px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: #ebdfda;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  background: #f2dbd9;
}
.button_close {
  background: var(--ion-color-primary);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border-radius: 26px;
  color: var(--color-black);
  cursor: pointer;
}
.button_close:hover {
  background: #f2dbd9;
}

.error-icon {
  margin: 25px auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACD;AAAC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAGH;;AAEA;EACC,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AACD;;AAEA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,oBAAA;AAAD;;AAGA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAAD;AAEC;EACC,gBAAA;AAAF;AAGC;EACC,mBAAA;EACA,gCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAFF;AAGE;EACC,mBAAA;AADH;AAKC;EACC,oCAAA;EACA,yBAAA;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,eAAA;AALF;AAOE;EACC,mBAAA;AALH;;AASA;EACC,iBAAA;AAND","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 35px;\n\tmargin: 0;\n\tborder-radius: 20px;\n\tbackground: var(--default-background);\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n}\n\n.title {\n\tfont-family: AppFontMedium, sans-serif;\n\tfont-size: 28px;\n\tline-height: 23px;\n\tletter-spacing: normal;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\tmargin-bottom: 15px;\n\ttext-transform: capitalize;\n}\n\n.info {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 18px;\n\tline-height: 16px;\n\tletter-spacing: normal;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\n\ttext-transform: none;\n}\n\n.button {\n\theight: 40px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\tmargin-top: 25px;\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t&_main {\n\t\tbackground: #ebdfda;\n\t\tfont-family: AppFont, sans-serif;\n\n\t\tfont-size: 15px;\n\t\tline-height: 25px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\tborder-radius: 26px;\n\t\ttext-transform: uppercase;\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n\n\t&_close {\n\t\tbackground: var(--ion-color-primary);\n\t\ttext-transform: uppercase;\n\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 15px;\n\t\tline-height: 25px;\n\t\tletter-spacing: 0.06em;\n\t\ttext-align: center;\n\n\t\tborder-radius: 26px;\n\t\tcolor: var(--color-black);\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n}\n.error-icon {\n\tmargin: 25px auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
